import React, { useState } from 'react'
import { View, ScrollView, TouchableOpacity } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Header, Screen, TextInput, Button, KeyboardAwareView } from '@components'
import { ScreenContactProps } from '@navigation'
import { Scope, SelectionItem } from '@utils'
import { GenericSelectionModal } from '../../../components/organisms/GenericSelectionModal'
import { useContactsListStore } from '@store'
import { getAddGhostContactStyles } from '../addGhostContact/styles'
import { usePaginateCities } from '@hooks'
import { useLanguage } from '@context'

export const AddScannedContact: React.FC<ScreenContactProps<'AddScannedContact'>> = ({ navigation, route }) => {
  const theme = useTheme()
  const { t, currentLanguage } = useLanguage()
  const styles = getAddGhostContactStyles(theme)
  
  const [searchText, setSearchText] = useState('')
  const { flatData: cities, isFetching: isFetchingCities, isFetchingNextPage: isFetchingNextPageCities, fetchNextPage: fetchNextPageCities, hasNextPage: hasNextPageCities } = usePaginateCities({ search: searchText, lang: currentLanguage })

  const [isAddressModalVisible, setIsAddressModalVisible] = useState(false)
  
  const [firstName, setFirstName] = useState('Carl')
  const [lastName, setLastName] = useState('Benson')
  const [email, setEmail] = useState('cbenson@regencysolutions.com')
  const [phone, setPhone] = useState('')
  const [address, setAddress] = useState<SelectionItem>()
  const [website, setWebsite] = useState('')

  const { addContact } = useContactsListStore()
  const handleSave = () => {
    addContact({
      id: '',
      firstName,
      lastName,
      fullName: `${firstName} ${lastName}`,
      email,
      phone,
      residence: address,
      website,
      gender: 'male' //TODO,
      //avatarUrl: `https://randomuser.me/api/portraits/${formData.gender === 'male' ? 'men' : 'women'}/${Math.floor(Math.random() * 10) + 1}.jpg`,
    }, [Scope.GHOST])
    navigation.goBack()
  }

  return (
    <Screen>
      <Header
        title={t('form.addNewContact')}
        iconLeft="arrowBack"
        iconColor={theme.colors.secondary}
        onPressLeft={() => navigation.goBack()}
      />

      <KeyboardAwareView isFullScreen>
        <ScrollView style={styles.container}>
          <View style={styles.form}>
            {/* Section Identité */}
            <TextInput
              title={t('form.firstName')}
              value={firstName}
              onChangeText={(text) => setFirstName(text)}
              placeholder={t('form.enterFirstName')}
              containerStyle={styles.input}
              iconRight="userPlus"
            />

            <TextInput
              title={t('form.lastName')}
              value={lastName}
              onChangeText={(text) => setLastName(text)}
              placeholder={t('form.enterLastName')}
              containerStyle={styles.input}
              iconRight="userPlus"
            />

            <TextInput
              title={t('contactsScreen.coordinates')}
              value={email}
              onChangeText={(text) => setEmail(text)}
              placeholder={t('form.email')}
              containerStyle={styles.input}
              keyboardType="email-address"
              iconRight="message"
            />

            <TextInput
              value={phone}
              onChangeText={(text) => setPhone(text)}
              placeholder={t('form.phoneNumber')}
              containerStyle={styles.input}
              keyboardType="phone-pad"
              iconRight="phone"
            />

            <TouchableOpacity onPress={() => setIsAddressModalVisible(true)}>
              <TextInput
                title={t('form.livingPlace')}
                value={address?.name}
                placeholder={t('form.livingPlace')}
                containerStyle={styles.input}
                iconRight="globe"
                editable={false}
                pointerEvents="none"
              />
            </TouchableOpacity>

            <TextInput
              value={website}
              onChangeText={(text) => setWebsite(text)}
              placeholder={t('form.website')}
              containerStyle={styles.input}
              keyboardType="url"
              iconRight="link2"
            />
          </View>
        </ScrollView>

        <View style={styles.footer}>
          <Button
            title={t('importContacts.addNewContactButton')}
            onPress={handleSave}
            unfilled={false}
          />
        </View>
      </KeyboardAwareView>
      
      <GenericSelectionModal
        isVisible={isAddressModalVisible}
        setIsVisible={(val) => setIsAddressModalVisible(val)}
        title={t('form.livingPlace')}
        placeholder={t('form.searchPlace')}
        availableItems={cities}
        selectedItems={[address].filter(Boolean) as SelectionItem[]}
        onSelectionChange={(items) => setAddress(items[0])}
        multiSelect={false}
        isFetching={isFetchingCities}
        fetchNextPage={fetchNextPageCities}
        hasNextPage={hasNextPageCities}
        isFetchingNextPage={isFetchingNextPageCities}
        onSearch={(text) => setSearchText(text)}
      />
    </Screen>
  )
}